// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"585":"f1b89be0","637":"6b15f25f","929":"b7262d1f","940":"7bd4ed10"}[chunkId] + ".css";
};